import { render, staticRenderFns } from "./MainMenuSumut.vue?vue&type=template&id=0e6858f4&lang=pug"
import script from "./MainMenuSumut.vue?vue&type=script&lang=js"
export * from "./MainMenuSumut.vue?vue&type=script&lang=js"
import style0 from "../../../assets/style/sumut/menu-sumut.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports